module.exports = __webpack_public_path__ + "static/img/3.571f617.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/sp/3.png
// module id = 0KoQ
// module chunks = 0